// src/routes/ProtectedRoute.tsx
import { useUser } from '../contexts/UserContext';
import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import AccessDeniedPermission from '@/feature/access-denied-permission/pages/AccessDeniedPermission';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermission?: string;
  redirectTo?: string;
}

const ProtectedRoute = ({
  children,
  requiredPermission,
  redirectTo = '/404'
}: ProtectedRouteProps) => {
  const { user, accessToken, permissions } = useUser();

  // 1. Sprawdzenie logowania
  if (!user && !accessToken) {
    return <Navigate to="/login" replace />;
  }

  // 2. Sprawdzenie uprawnień
  if (requiredPermission && !permissions?.includes(requiredPermission)) {
    return <AccessDeniedPermission />;
  }

  // 3. Dostęp OK
  return <>{children}</>;
};

export default ProtectedRoute;
